import {
  USERINFO_STATUS,
  CURRENT_STATUS,
} from '../redux/constants/ActionTypes';
import { defaultState as userState } from '../redux/reducers/userinfo';
import { defaultState as currentState } from '../redux/reducers/current';

export default class ApiManager {
  static loadApiStatus() {
    const apiStatus = {
      current: currentState,
      user: userState,
    };

    let state_str = window.localStorage.getItem(USERINFO_STATUS);
    let savedState;
    if (state_str) {
      try {
        savedState = JSON.parse(state_str);
        apiStatus.user = savedState;
      } catch (e) {
        console.trace(e);
      }
    }

    state_str = window.localStorage.getItem(CURRENT_STATUS);
    if (state_str) {
      try {
        savedState = JSON.parse(state_str);
        apiStatus.current = savedState;
      } catch (e) {
        console.trace(e);
      }
    }

    return apiStatus;
  }

  static clearApiStatus() {
    window.localStorage.removeItem(USERINFO_STATUS);
    window.localStorage.removeItem(CURRENT_STATUS);
  }

  static saveState = state => {
    try {
      const serializedState = JSON.stringify(state);
      window.localStorage.setItem('state', serializedState);
    } catch (e) {
      console.trace(e);
    }
  };
}
